import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "components/common/Layout";
import { ValidateButton } from "./ValidateButton";
import { DisplayedError } from "services/errors";
import { useDocumentTitle } from "hooks/useDocumentTitle";
import { H2_DEFAULT_MARGIN_TOP } from "./heading";

type Props = {
    error: DisplayedError;
};

const ErrorPage = (props: Props) => {
    const { t } = useTranslation();
    useDocumentTitle(t(`${props.error.header}`));

    const renderErrorMessage = () => {
        return (
            <>
                <h1>{t(`${props.error.header}`)}</h1>
                <p>{t(`${props.error.body}`)}</p>
            </>
        );
    };
    return (
        <Layout>
            <Wrapper>
                {renderErrorMessage()}
                <Link to="/">
                    <ValidateButton>
                        <span>{`${t("backToHome")}`}</span>
                    </ValidateButton>
                </Link>
            </Wrapper>
        </Layout>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2rem;

    > h1 {
        font-size: 1.5rem;
        letter-spacing: -1px;
        margin-bottom: 1rem;
        font-weight: 500;
    }
    /* Explanation text, not a heading (RGAA 9.1): it keeps the look of the former h2. */
    > p {
        margin-top: ${H2_DEFAULT_MARGIN_TOP};
        font-size: 1rem;
        margin-bottom: 2rem;
        text-align: center;
        font-weight: 500;
    }
`;

export default ErrorPage;
